/**
 * Generate a client ID (UUID v4) for OAuth2 client_credentials flow.
 */
export const generateClientId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Generate a client secret: 32 random bytes, hex-encoded (64 chars).
 */
export const generateClientSecret = () => {
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const bytes = new Uint8Array(32);
    crypto.getRandomValues(bytes);
    return Array.from(bytes)
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  }
  // Fallback (less random; only used in environments without crypto)
  let secret = "";
  for (let i = 0; i < 64; i += 1) {
    secret += Math.floor(Math.random() * 16).toString(16);
  }
  return secret;
};
